import { useState } from 'react';

export const useSearchDialog = () => {
  const [showSearchDialog, setShowSearchDialog] = useState(false);

  const handleSearch = () => {
    setShowSearchDialog(true);
  };

  const handleSearchSubmit = (filters: BanHangPayload) => {
    console.log('Search filters:', filters);
    // Implement search functionality here
  };

  const closeSearchDialog = () => {
    setShowSearchDialog(false);
  };

  return {
    showSearchDialog,
    handleSearch,
    handleSearchSubmit,
    closeSearchDialog
  };
};
